export const ROUTES = {
  home: "/",
  workshop: "/workshops/gleichgewicht-als-fundament",
  danke: "/danke",
  impressum: "/impressum",
  datenschutz: "/datenschutz",
  teilnahmebedingungen: "/teilnahmebedingungen",
};

// Central QR routing table: printed QR codes point to /qr/<code> forever.
// To retarget a QR code later, change only the value here.
export const QR_TARGETS = {
  flyer: ROUTES.workshop,
  social: ROUTES.workshop,
  whatsapp: ROUTES.workshop,
};

export const ANCHORS = {
  top: "#top",
  erlebnis: "#erlebnis",
  buchung: "#buchung",
};
